let qdata = {
    name: "Измервания и анализи",
    path: process.env.VUE_APP_QDATA_URL,
    target: true,
    meta: { icon: "reports" },
    groups: ["TestMainGroup"],
  };

  export default qdata;
